<template>
  <v-container>
    <v-form v-model="valid">
      <v-card outlined hover>
        <v-card-title class="estimate-title">
          <v-row>
            <v-spacer></v-spacer>
            <div>{{ get("title") }}</div>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-title>
        <v-card-text class="estimate-body">
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field ref="nameField"
                dense
                :label="get('name')"
                v-model="estimate.name"
                required
                outlined
                filled
                :rules="rulesName"
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field
                class="text-field"
                dense
                :label="get('address')"
                v-model="estimate.address"
                outlined
                filled
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field
                class="text-field"
                dense
                :label="get('city')"
                v-model="estimate.city"
                outlined
                filled
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field
                class="text-field"
                dense
                :label="get('zipcode')"
                v-model="estimate.zipcode"
                outlined
                filled
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field
                class="text-field"
                dense
                :label="get('email')"
                prepend-icon="mdi-at"
                v-model="estimate.email"
                outlined
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field
                class="text-field"
                dense
                prepend-icon="mdi-card-account-phone"
                :label="get('phone')"
                v-model="estimate.phone"
                outlined
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-select
                v-model="selectedProjects"
                :items="projects"
                attach
                chips
                class="text-field"
                dense
                deletable-chips
                :label="get('project')"
                multiple
              ></v-select>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-textarea
                class="text-field"
                dense
                :label="get('message')"
                v-model="estimate.message"
                outlined
                :hint="get('solicitor')"
              />
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12">
              <v-text-field
                dense
                class="text-field"
                prepend-icon="mdi-lock"
                :label="verifyLabel"
                :hint="get('verify')"
                v-model="answer"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="estimate-actions">
          <v-spacer></v-spacer>
          <v-btn outlined @click="onSubmit"
            ><v-icon>mdi-save</v-icon>Submit</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import EstimateService from "@/_services/api/estimate-service"
import localizationService from "@/_services/localization-service";
import notificationMixin from "@/mixins/notification-mixin";
import store from "@/store";
export default {
  name: "estimate-card",

  components: {
  },

  mixins: [notificationMixin],

  created() {
    this.verify[0] = Math.floor(Math.random() * 3) + 1;
    this.verify[1] = Math.floor(Math.random() * 3) + 1;
    this.getLocalization();
  },

  mounted() {
  },

  data: () => ({
    answer: "",
    estimate: {
      id: 0,
      name: "",
      address: "",
      city: "",
      estimateDate: new Date(),
      localizationPairs: [],
      zipcode: "",
      message: "",
      email: "",
      phone: "",
      projectType: "",
    },
    label: "Enter your message",
    projects: ["Roof", "Gutter", "Siding", "Windows"],
    rulesName: [],
    selectedProjects: [],
    valid: false,
    verify: [0, 0],
    verifyLabel: "",
    waterImage: require("@/assets/rain-3.jpg"),
  }),

  methods: {
    get(id) {
      var text = "undefined";
      var pair = this.localizationPairs.find(p => p.id == id);
      if(pair != null) {
        text = pair.text;
      }

      return text;
    },
    
    getLocalization() {
      this.localizationPairs = localizationService.get("estimate");
      if(store.getters.getLocalization){
        this.rulesName = [
          (v) => !!v || "Name is required",
          (v) => (v || "").length <= 255 || "Name must be 255 characters or less",
        ];
        this.projects = ["Roof", "Gutter", "Siding", "Windows"];
        this.verifyLabel = 
          "Verify " + this.verify[0] + " + " + this.verify[1];
      } else {
        this.rulesName = [
          (v) => !!v || "El nombre es obligatorio",
          (v) => (v || "").length <= 255 || "El nombre debe tener 255 caracteres o menos",
        ];
        this.projects = ["Techo", "Canal", "Vía muerta", "Ventanas"]
        this.verifyLabel = 
          "Verificar " + this.verify[0] + " + " + this.verify[1];
      }

    },

    onSubmit() {
      const total = this.verify[0] + this.verify[1];
      const result = {
        statusCode: 200,
        errors: [],
      };
      if (this.estimate.name.length == 0) {
        (result.statusCode = 400), result.errors.push("Name is required");
      }
      if (this.estimate.email.length == 0 && this.estimate.phone.length == 0) {
        (result.statusCode = 400),
          result.errors.push("Email or Phone is required");
      }
      if (this.answer != total) {
        result.statusCode = 400;
        result.errors.push("Verify total does not add up");
      }
      if (result.statusCode == 200) {
        this.selectedProjects.forEach((type) => {
          if (this.estimate.projectType.length > 0) {
            this.estimate.projectType += ", ";
          }
          this.estimate.projectType += type;
        });
        // console.log('Estimate: ', this.estimate)

        EstimateService.save(this.estimate).then(() => {
          const notification = {
            title: "Estimate",
            status: "success",
            messages: ["The estimate was saved", "We will reach out shortly" ], 
          };
          store.commit("setNotification", notification);
        });
        } else {
            const notification = {
              title: "Estimate",
              status: "error",
              messages: ["The estimate was not saved", "Please try again or call us directly" ], 
            };
            store.commit("setNotification", notification);
        } 
    },

    onStatusAlertClosed() {},
  },

  watch: {
    "$store.state.localization"() {
      // console.log("estimate.localization...");
      this.getLocalization();
      // this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.estimate-actions {
  background-color: var(--v-anchor-base) !important;
  color: white;
  margin-top: -30px;
}
.estimate-title {
  background-color:var(--v-anchor-base) !important;
  color: white;
  margin-bottom: 10px;
}

.estimate {
  background: linear-gradient(to bottom, #ffccff 0%, #e600e6 100%);
}
.text-field {
  margin-top: -30px !important;
}
.theme--light.v-card > .v-card__text {
  background: linear-gradient(
    to bottom,
    $light-gradient-low-color 10%,
    $light-gradient-high-color 100%
  );
}
.theme--dark.v-card > .v-card__text {
  background: linear-gradient(
    to bottom,
    $dark-gradient-low-color 10%,
    $dark-gradient-high-color 100%
  );
}

</style>
